<template>
  <div class="flex items-center justify-center mt-8 md:mt-20">
    <div class="flex flex-col md:flex-row">
      <div
        @click="useBeneficiary"
        class="box cursor-pointer flex flex-col items-center justify-center mb-4 md:mr-6"
      >
        <div
          class="flex items-center justify-center border border-none bg-pink-1 p-4 rounded-full"
        >
          <people-icon />
        </div>
        <p class="text-base font-normal mt-8 text-root-4">Use Beneficiary</p>
      </div>
      <div
        @click="useRecipient"
        class="box flex cursor-pointer flex-col items-center justify-center"
      >
        <div
          class="flex items-center justify-center border border-none bg-pink-1 p-4 rounded-full"
        >
          <plus-icon-two />
        </div>
        <p class="text-base font-normal mt-8 text-root-4">New Recipient</p>
      </div>
    </div>
    <beneficiary-dialog
      v-if="showBeneficiaryDialog"
      :showDialog="showBeneficiaryDialog"
      @toReview="toReview"
      @closeDialog="closeBeneficiaryDialog"
    />
  </div>
</template>

<script>
export default {
  name: 'Recipient',
  components: {
    PeopleIcon: () => import('@/assets/icons/PeopleIcon.vue'),
    PlusIconTwo: () => import('@/assets/icons/PlusIconTwo.vue'),
    BeneficiaryDialog: () => import('./BeneficiaryDialog')
  },
  data () {
    return {
      showBeneficiaryDialog: false
    }
  },
  methods: {
    useBeneficiary () {
      this.showBeneficiaryDialog = true
    },
    useRecipient () {
      this.$emit('showRecipientInformation')
    },
    toReview () {
      this.$emit('toReview')
    },
    closeBeneficiaryDialog () {
      this.showBeneficiaryDialog = false
    }
  }
}
</script>
<style scoped>
.box {
  height: 239.67px;
  width: 239.67px;
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 1px 3px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
</style>
